import React from 'react';
import _ from 'lodash';

export default function ErrorDescription({ error }) {
  if (typeof error === 'string') return <>{error}</>;
  if (!!error && typeof error === 'object') {
    const response: any = _.result(error, 'response', {});
    const errorData: any = _.result(response, 'data', { description: '', msg: '' });
    const status = error.status || response.status;
    const statusText = error.statusText || response.statusText || '';
    const message = error.message || errorData.message;
    return status || message || errorData?.description ? (
      <>
        {!!status && <div>{`(${status})${statusText}`}</div>}
        {!!message && <div>{message}</div>}
        {!!errorData?.description && <div>{errorData?.description}</div>}
        {!!errorData?.msg && <div>{errorData?.msg}</div>}
      </>
    ) : (
      <>{JSON.stringify(error || '')}</>
    );
  } else return null;
}
